<template>
  <page :custom-style="pageStyle">
    <download-bar ref="download" />
    <div
      v-if="!miniProgramEnv.isMiniProgram"
      class="cms-nav-bar"
      :style="{ top: downLoadHeight + 'px!important' }"
    >
      <maple-nav-bar
        left-arrow
        :safe-top-distance="statusBarHeight"
        :title="navBarTitle"
        @click-left="goBack"
      />
    </div>
    <div
      v-if="!miniProgramEnv.isMiniProgram"
      :style="{ height: 44 + statusBarHeight + 'px' }"
    ></div>
    <div class="page-container">
      <div
        v-for="(item, index) in similyGoods"
        :key="index"
        v-expose-track="{
          similar_goods: {
            mapId: item.mapId,
            data: {
              sku_id: Number(item.sku_id),
              goodsStatus: item.ssuInfo.statusInfo.status,
              from_sku_id: Number(query.sku_id),
              ssu_id: item.ssuInfo.ssuId,
              sku_pos: index,
              tag_name_similar:
                (item.recommend_tags && item.recommend_tags.tag) || '',
              goods_status: item.ssuInfo.status,
              price: item.ssuInfo.priceSpm || ''
            }
          }
        }"
        class="good-card"
      >
        <SoleGoods :sku="item" :good-width="72" :from-page="'similar'" />
      </div>
      <empty v-if="showEmpty"></empty>
      <div v-if="recommendGoods.length > 0" class="header">
        <div class="title">精品推荐</div>
      </div>
      <div class="tris-goods-list">
        <div
          v-for="(item, index) in recommendGoods"
          :key="item.sku_id"
          v-expose-track="{
            similar_goods: {
              mapId: 'recommendGood',
              data: {
                ssu_id: item.ssuInfo.ssuId,
                sku_id: item.sku_id,
                sku_pos: index,
                price: item.ssuInfo.priceSpm || ''
              }
            }
          }"
          class="tris-goods-card"
          :style="(index + 1) % 3 === 0 ? 'margin-right:0' : ''"
        >
          <TrisScrollGood
            :good-width="112"
            :sku="item"
            :from-page="'similar'"
          />
        </div>
      </div>

      <div class="no-more">没有更多了</div>

      <CartFloatWindow v-track="$trackMap.similarGoods.goShopCart" />
    </div>
  </page>
</template>

<script>
import empty from './components/empty'
import { API } from '@/api'
import SoleGoods from './components/sole-good'
import TrisScrollGood from './components/tris-scroll-good'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import downloadBar from '@/common/widgets/downloadBar'
import { miniProgramEnv } from '@/defines/environment'
export default {
  name: 'SimilarGoods',
  components: {
    empty,
    SoleGoods,
    CartFloatWindow,
    downloadBar,
    TrisScrollGood
  },
  onLogin() {
    window.location.reload()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '同类商品推荐'
      vm.initData(to.query)
    })
  },
  data() {
    return {
      showEmpty: false,
      showCartFloatWindow: false,
      navBarTitle: '同类商品推荐',
      pageStyle: {
        backgroundColor: '#fff',
        minHeight: '100vh',
        paddingTop: '0'
      },
      downLoadHeight: 0,
      recommendGoods: [],
      similyGoods: [],
      miniProgramEnv,
      query: {}
    }
  },
  mounted() {
    this.downLoadHeight =
      this.$refs.download?.$refs?.downloadWrap?.offsetHeight || 0
    this.pageStyle.paddingTop = `${this.downLoadHeight}px`
  },
  methods: {
    async initData(query) {
      // eslint-disable-next-line camelcase
      const { sale_c1_id, sale_c2_id, bi_id, sku_id } = query
      this.query = query
      const recommendKeys = JSON.stringify([
        {
          biId: bi_id,
          skuId: sku_id,
          saleC1Id: sale_c1_id,
          saleC2Id: sale_c2_id
        }
      ])

      // 获取同类推荐
      this.getRecommendGoods('similar', {
        moduleKey: 14,
        // eslint-disable-next-line camelcase
        extraParams: JSON.stringify([{ id: sku_id || '', type: 'SKU' }]),
        recommendKeys
      })
      // 获取精品推荐
      this.getRecommendGoods('recommend', {
        moduleKey: 15,
        recommendKeys
      })
    },
    /**
     * 获取推荐接口
     * @params {string} type similar => 同类推荐 recommend=> 精品推荐
     * @params {object} params 参数对象
     */
    async getRecommendGoods(type, params) {
      const res = await API.similygoods.getGoodsInfoLocation(params)
      if (type === 'similar') {
        this.similyGoods = (res?.[0].rows || []).map((item, index) => {
          const ssuInfo = item?.ssuList?.[0]
          item.ssuInfo = ssuInfo
          // 当前SKU商品
          if (Number(this.query.sku_id) === ssuInfo.sku_id) {
            item.currentSku = true
            item.mapId = 'fromGood'
            item.ssuInfo.traceType = 'goodsPlusCart'
            item.ssuInfo.traceType2 = 'goDetail'
            item.ssuInfo.traceInfo = {
              sku_id: Number(this.query.sku_id || 0),
              sku_pos: 0
            }
          } else {
            // 推荐的同品商品
            item.currentSku = false
            item.mapId = 'similyGood'
            item.ssuInfo.traceType = 'similarGoodsPlusCart'
            item.ssuInfo.traceType2 = 'similarGoodsGoDetail'
            item.ssuInfo.traceInfo = {
              ssu_id: ssuInfo.ssu_id || 0,
              sku_id: Number(item.ssuId || 0),
              sku_pos: index,
              from_sku_id: Number(this.query.sku_id || 0),
              tag_name_similar: item.recommend_tags?.tag || ''
            }
          }
          return item
        })
        if (this.similyGoods.length === 0) {
          this.showEmpty = true
        }
      } else {
        // 精品推荐
        this.recommendGoods = (res?.[0].rows || []).map((item, index) => {
          const ssuInfo = item.ssuList[0]
          item.ssuInfo = ssuInfo
          item.ssuInfo.traceType = 'recommendGoodsPlusCart'
          item.ssuInfo.traceType2 = 'recommendGoodsGoDetail'
          item.ssuInfo.traceInfo = {
            ssu_id: item.ssuInfo?.ssu_id || 0,
            sku_id: Number(item.sku_id || 0),
            sku_pos: index
          }
          return item
        })
      }
    },
    goBack() {
      this.$track(this.$trackMap.similarGoods.goBack)
      this.$back()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.page-container {
  padding: 0.2rem 0;
}

.cms-nav-bar {
  position: fixed;
  top: 0;
  z-index: 500;

  width: 100vw;
}

.tris-goods-list {
  display: flex;

  padding: 0 0.2rem;

  flex-wrap: wrap;
  justify-content: flex-start;

  .tris-goods-card {
    position: relative;

    width: 2.24rem;
    margin-right: 0.16rem;
    margin-bottom: 0.16rem;
    .good-top-tag {
      position: absolute;
      top: -0.2rem;
      left: -0.32rem;
      z-index: 99;

      transform: scale(0.5);

      height: 0.64rem;

      padding: 0 0.16rem;

      line-height: 0.64rem;
    }
  }
}

.header {
  display: flex;

  justify-content: center;
  align-items: center;

  .title {
    position: relative;

    margin: 0.4rem 0 0.32rem;

    font-size: 0.28rem;

    font-weight: bold;
    color: #262626;

    &::before {
      position: absolute;

      top: 0.12rem;
      left: -0.7rem;

      width: 0.52rem;
      height: 0.02rem;

      background-image: linear-gradient(-90deg, #666 0%, #f6f6f6 100%);

      content: '';
    }
    &::after {
      position: absolute;

      top: 0.12rem;
      right: -0.7rem;

      width: 0.52rem;
      height: 0.02rem;

      background-image: linear-gradient(-90deg, #f6f6f6 0%, #666 100%);

      content: '';
    }
  }
}

.no-more {
  height: 30px;

  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #908f8e;
}
</style>
